import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Typography } from 'src/components/ui/typography';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

const SelfSignupHeader = ({ isLogin = false }) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" flexDirection="column" gap={{ xs: '16px', sm: '6px' }}>
      <Typography className="tw:text-text-primary tw:text-[24px] tw:font-semibold tw:leading-8 tw:font-['Lato',sans-serif]">
        {isLogin ? t(T.welcomeAndSignIn) : t(T.welcomeText3)}
      </Typography>
      <Box display="flex" flexDirection="column" gap="8px">
        <Typography className="tw:text-[14px] tw:text-text-secondary tw:font-['Lato',sans-serif] tw:font-normal tw:leading-[20px]">
          {t(T.signupInfo)}
        </Typography>
      </Box>
    </Box>
  );
};

export default SelfSignupHeader;
